import { createCookieManager } from './cookie-manager-factory'
import { isProduction } from '../env'

export const COOKIE_KEYS = Object.freeze({
  userAuth: { name: 'userAuth', options: { path: '/', domain: isProduction ? '.mobileaction.co' : undefined } },
  impersonatorUsername: { name: 'impersonatorUsername', options: { expires: 7 } },
  pdfPageParams: { name: 'pdfPageParams', options: { expires: 1 } },
  taxonomyNotification: { name: 'TaxonomyNotification', expires: 365 },
  onboarding: 'Onboarding',
})

const cookieManager = createCookieManager(COOKIE_KEYS, {
  prefix: 'MA_',
  suffix: isProduction ? '' : '_dev',
  globalCookieOptions: {
    secure: isProduction,
    expires: 30,
    sameSite: 'strict',
  },
})

export { cookieManager }
